import {EquipmentType, SelectOption} from '@hconnect/common/types'

import {COMBINED_KILN_OPTION_VALUE} from '../consts'
import {EquipmentDto} from '../types'

export const mapToEquipmentOptionsWithCombinedKiln = (
  kilnLabel: string,
  equipments: EquipmentDto[] | undefined = []
): SelectOption<string>[] => {
  const equipmentsWithoutKiln = equipments.filter(
    (equipment) => equipment.equipmentType !== EquipmentType.KILN
  )

  const equipmentOptions = equipmentsWithoutKiln.map((equipment) => ({
    label: equipment.description,
    value: equipment.equipmentNumber
  }))

  const anyKilnEquipmentExist = equipments.length > equipmentsWithoutKiln.length
  if (anyKilnEquipmentExist) {
    equipmentOptions.unshift({
      label: kilnLabel,
      value: COMBINED_KILN_OPTION_VALUE
    })
  }

  return equipmentOptions
}
